export const initPageHeader = (headerEl) => {
  const menuToggle = headerEl?.querySelector('[data-toggle="mobile-nav"]');
  const navAnchorLinks =
    headerEl?.querySelectorAll('#main-nav a[href*="#"]') || [];

  menuToggle?.addEventListener("click", (e) => {
    e.preventDefault();

    const html = headerEl.querySelector("html");
    const mainNav = document.getElementById("main-nav");

    menuToggle?.classList?.toggle("is-open");
    html?.classList?.toggle("noscroll");
    mainNav?.classList?.toggle("is-open");
  });

  for (const anchor of navAnchorLinks) {
    anchor.addEventListener("click", () => {
      if (anchor.getAttribute("href").indexOf("#") !== 0) {
        return;
      }

      const html = headerEl.querySelector("html");
      const mainNav = document.getElementById("main-nav");

      menuToggle?.classList?.remove("is-open");
      html?.classList?.remove("noscroll");
      mainNav?.classList?.remove("is-open");
    });
  }

  const subnavToggles = headerEl?.querySelectorAll(".subnav-toggle") || [];
  for (const toggle of subnavToggles) {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = toggle.getAttribute("aria-expanded") === "true";
      closeAllSubnavs();

      if (!isOpen) {
        toggle.setAttribute("aria-expanded", false);
        toggle.setAttribute("aria-expanded", true);
        document.addEventListener("click", closeAllSubnavs);
      }
    });
  }

  function closeAllSubnavs() {
    document.removeEventListener("click", closeAllSubnavs);
    for (const toggle of subnavToggles) {
      toggle.setAttribute("aria-expanded", false);
    }
  }
};
